import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
    selector: "chevron-left-icon",
    templateUrl: "./chevron-left-icon.component.svg",
    styleUrl: "./chevron-left-icon.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChevronLeftIconComponent {
    size = input<number>(15);
}
